import React, { ReactElement } from "react";
import {
  StyledBoxContainer,
  StyledBoxHeader,
  StyledBoxContent,
} from "./BoxContainerStyles";
import { type IconTypes, SelectedIcon } from "../../Icons";
import {
  sanitiseString,
  concatStringFromClassesArrayList,
} from "../../Utils/StringUtils";
import { ActionMenu } from "../ActionMenu";
export interface Props {
  id: string;
  dataTestId?: string;
  children?: ReactElement;
  borderColor?: string;
  title: string;
  titleColor?: string;
  classes?: string;
  borderWidth?: number;
  titleTag?: string;
  iconType?: IconTypes;
  actionMenu?: ReturnType<typeof ActionMenu>;
}

export const BoxContainer = (props: Props) => {
  const sanitisedId = sanitiseString(props.id);
  const sanitisedDataTestId = sanitiseString(props.dataTestId);
  const titleTag = props.titleTag || "h3";

  const classList = {
    defaultClass: "ons-box-container",
    optionalClasses: [props.classes || null],
  };

  const className = concatStringFromClassesArrayList(classList);

  return (
    <StyledBoxContainer
      id={sanitisedId}
      data-testid={sanitisedDataTestId}
      className={className}
      $borderColor={props.borderColor}
      $borderWidth={props.borderWidth}
    >
      <StyledBoxHeader
        className="ons-u-pl-s ons-u-pr-s ons-u-pt-s ons-u-pb-s"
        $borderColor={props.borderColor}
        $titleColor={props.titleColor}
        id={`${sanitisedId}-header`}
        data-testid={`${sanitisedDataTestId}-header`}
      >
        {React.createElement(
          titleTag,
          {
            className: "ons-u-mb-no",
          },
          props.title,
          props.iconType !== undefined && (
            <span className="ons-u-ml-m ons-u-fs-l">
              <SelectedIcon iconType={props.iconType} classes="ons-icon--l" />
            </span>
          )
        )}
        {props.actionMenu && <div>{props.actionMenu}</div>}
      </StyledBoxHeader>
      <StyledBoxContent
        id={`${sanitisedId}-content`}
        data-testid={`${sanitisedDataTestId}-content`}
        className="ons-u-mb-s ons-u-ml-s ons-u-mr-s"
      >
        {props.children}
      </StyledBoxContent>
    </StyledBoxContainer>
  );
};
